export default "__VITE_ASSET__CvrL4Xlr__"